// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProtectedContent_loadingContainer__SSMRH {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
  }
  
  .ProtectedContent_spinner__s\\+b1A {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    border-left-color: #09f;
    animation: ProtectedContent_spin__2X689 1s linear infinite;
    margin-bottom: 16px;
  }
  
  .ProtectedContent_loadingText__jl7XJ {
    font-size: 18px;
    color: #333;
    font-weight: 500;
  }
  
  @keyframes ProtectedContent_spin__2X689 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/private/ProtectedContent.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,uBAAuB;IACvB,0DAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".loadingContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n  }\n  \n  .spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-radius: 50%;\n    border-left-color: #09f;\n    animation: spin 1s linear infinite;\n    margin-bottom: 16px;\n  }\n  \n  .loadingText {\n    font-size: 18px;\n    color: #333;\n    font-weight: 500;\n  }\n  \n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `ProtectedContent_loadingContainer__SSMRH`,
	"spinner": `ProtectedContent_spinner__s+b1A`,
	"spin": `ProtectedContent_spin__2X689`,
	"loadingText": `ProtectedContent_loadingText__jl7XJ`
};
export default ___CSS_LOADER_EXPORT___;
